import { useEffect } from 'react'
import CountUp from 'react-countup';
import { useNavigate } from "react-router-dom";
import './feeCard.scss';
import { useAdminPlatformFee } from './api/adminFeeApi';
import { WaitingLoader } from '../../hooks/buttonLoad';


const AdminWithdrawFee = () => {
    const navigate = useNavigate();
    const { data: getWidget, isLoading } = useAdminPlatformFee()

    useEffect(() => {
        const animateCards = () => {
            const cards = document.querySelectorAll('.custm-dashboard_cd');
            cards.forEach(triggerCardAnimation);
        };

        const triggerCardAnimation = (card) => {
            card.classList.add('animate');
            removeAnimationAfterDelay(card);
        };

        const removeAnimationAfterDelay = (card) => {
            setTimeout(() => {
                card.classList.remove('animate');
            }, 1000);
        };

        const interval = setInterval(animateCards, 5000);
        return () => clearInterval(interval);
    }, []);

    const getCurrencyData = (network, currency) =>
        getWidget?.data?.data?.find(item => item.network === network && item.currency === currency);

    const polygonPol = getCurrencyData("polygon", "pol");
    const polygonRou = getCurrencyData("polygon", "rou");
    const polygonUsdt = getCurrencyData("polygon", "usdt");
    const binanceBnb = getCurrencyData("binance", "bnb");
    const binanceUsdt = getCurrencyData("binance", "usdt");
    const ethereumEth = getCurrencyData("ethereum", "eth");
    const ethereumUsdt = getCurrencyData("ethereum", "usdt");
    const solanaSol = getCurrencyData("solana", "sol");
    const solanaUsdt = getCurrencyData("solana", "usdt");
    const tronTrx = getCurrencyData("tron", "trx");
    const tronUsdt = getCurrencyData("tron", "usdt");

    const getDecimalPlaces = (value, defaultDecimals = 3) => {
        if (typeof value !== 'number') return 0;
        return value % 1 !== 0 ? defaultDecimals : 0;
    };

    const handleNavigate = (currency, network) => {
        navigate("/platformfee-history", {
            state: { currency, network }
        });
    };


    return (
        <>
            {isLoading && <WaitingLoader />}
            <div>
                <h3>Admin Platform Fee Management</h3>
            </div>
            <div className="row gy-4 mt-4">

                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>Polygon</h4>
                        <div className="custm-dashboard_cd">
                            <div className="custm-dashboard_rcnt tp">
                                <div className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white" >
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('pol', 'polygon')}
                                            style={{ all: 'unset', cursor: 'pointer', marginLeft: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb">POL Count</div>
                                            <div className="custm-dashboard_vl">
                                                <CountUp end={polygonPol?.txnCount || 0} />
                                            </div>
                                        </button>
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('usdt', 'polygon')}
                                            style={{ all: 'unset', cursor: 'pointer', marginRight: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb">POL USDT Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={polygonUsdt?.txnCount || 0} /> </div>
                                        </button>

                                    </div>
                                </div>
                            </div>
                            <div className="custm-dashboard_rcnt bm">
                                <div className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={polygonPol?.currentBal || 0} decimals={getDecimalPlaces(polygonPol?.currentBal)} />
                                                {polygonPol?.image && (
                                                    <img
                                                        src={polygonPol?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={polygonUsdt?.currentBal || 0} decimals={getDecimalPlaces(polygonUsdt?.currentBal)} />
                                                {polygonUsdt?.image && (
                                                    <img
                                                        src={polygonUsdt?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>Polygon ROU</h4>
                        <div className="custm-dashboard_cd">
                            <div className="custm-dashboard_rcnt tp">
                                <div className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('rou', 'polygon')}
                                            style={{ all: 'unset', cursor: 'pointer', marginLeft: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb"> ROU Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={polygonRou?.txnCount || 0} /> </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="custm-dashboard_rcnt bm">
                                <button className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={polygonRou?.currentBal || 0} decimals={getDecimalPlaces(polygonRou?.currentBal)} />
                                                {polygonRou?.image && (
                                                    <img
                                                        src={polygonRou?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>BNB</h4>
                        <div className="custm-dashboard_cd">
                            <div className="custm-dashboard_rcnt tp">
                                <div className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('bnb', 'binance')}
                                            style={{ all: 'unset', cursor: 'pointer', marginLeft: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb"> BNB Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={binanceBnb?.txnCount || 0} /> </div>

                                        </button>
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('usdt', 'binance')}
                                            style={{ all: 'unset', cursor: 'pointer', marginRight: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb">BNB USDT Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={binanceUsdt?.txnCount || 0} /> </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="custm-dashboard_rcnt bm">
                                <button className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white" >
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={binanceBnb?.currentBal || 0} decimals={getDecimalPlaces(binanceBnb?.currentBal)} />
                                                {binanceBnb?.image && (
                                                    <img
                                                        src={binanceBnb?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={binanceUsdt?.currentBal || 0} decimals={getDecimalPlaces(binanceUsdt?.currentBal)} />
                                                {binanceUsdt?.image && (
                                                    <img
                                                        src={binanceUsdt?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>ETH</h4>
                        <div className="custm-dashboard_cd">
                            <div className="custm-dashboard_rcnt tp">
                                <div className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('eth', 'ethereum')}
                                            style={{ all: 'unset', cursor: 'pointer', marginLeft: '10px' }}

                                        >
                                            <div className="custm-dashboard_lb"> ETH Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={ethereumEth?.txnCount || 0} /> </div>
                                        </button>
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('usdt', 'ethereum')}
                                            style={{ all: 'unset', cursor: 'pointer', marginRight: '10px' }}

                                        >
                                            <div className="custm-dashboard_lb">ETH USDT Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={ethereumUsdt?.txnCount || 0} /> </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="custm-dashboard_rcnt bm">
                                <button className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={ethereumEth?.currentBal || 0} decimals={getDecimalPlaces(ethereumEth?.currentBal)} />
                                                {ethereumEth?.image && (
                                                    <img
                                                        src={ethereumEth?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={ethereumUsdt?.currentBal || 0} decimals={getDecimalPlaces(ethereumUsdt?.currentBal)} />
                                                {ethereumUsdt?.image && (
                                                    <img
                                                        src={ethereumUsdt?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>Tron</h4>
                        <div className="custm-dashboard_cd">
                            <div className="custm-dashboard_rcnt tp">
                                <div className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('trx', 'tron')}
                                            style={{ all: 'unset', cursor: 'pointer', marginLeft: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb">TRX Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={tronTrx?.txnCount || 0} /> </div>
                                        </button>
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('trx', 'tron')}
                                            style={{ all: 'unset', cursor: 'pointer', marginRight: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb">TRX USDT Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={tronUsdt?.txnCount || 0} /> </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="custm-dashboard_rcnt bm">
                                <button className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={tronTrx?.currentBal || 0} decimals={getDecimalPlaces(tronTrx?.currentBal)} />
                                                {tronTrx?.image && (
                                                    <img
                                                        src={tronTrx?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={tronUsdt?.currentBal || 0} decimals={getDecimalPlaces(tronUsdt?.currentBal)} />
                                                {tronUsdt?.image && (
                                                    <img
                                                        src={tronUsdt?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>SOL</h4>
                        <div className="custm-dashboard_cd">
                            <div className="custm-dashboard_rcnt tp">
                                <div className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white" >
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('sol', 'solana')}
                                            style={{ all: 'unset', cursor: 'pointer', marginLeft: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb"> SOL Count</div>
                                            <div className="custm-dashboard_vl"><CountUp end={solanaSol?.txnCount || 0} /> </div>
                                        </button>
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => handleNavigate('usdt', 'solana')}
                                            style={{ all: 'unset', cursor: 'pointer', marginRight: '10px' }}
                                        >
                                            <div className="custm-dashboard_lb"> SOL USDT</div>
                                            <div className="custm-dashboard_vl"><CountUp end={solanaUsdt?.txnCount || 0} /> </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="custm-dashboard_rcnt bm">
                                <button className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={solanaSol?.currentBal || 0} decimals={getDecimalPlaces(solanaSol?.currentBal)} />
                                                {solanaSol?.image && (
                                                    <img
                                                        src={solanaSol?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="custm-dashboard_lb">Amount</div>
                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                <CountUp end={solanaUsdt?.currentBal || 0} decimals={getDecimalPlaces(solanaUsdt?.currentBal)} />
                                                {solanaUsdt?.image && (
                                                    <img
                                                        src={solanaUsdt?.image}
                                                        alt="Currency Icon"
                                                        style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            borderRadius: '50%',
                                                            verticalAlign: 'middle',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>





            </div >
        </>

    )
}

export default AdminWithdrawFee;
